import React, { useState, useEffect } from 'react';
import ComingSoon from './ComingSoon';

const PasscodeGate = ({ children }) => {
  // Toggle for easy enable/disable - set to false to disable passcode protection
  const PASSCODE_ENABLED = false;
  const CORRECT_PASSCODE = 'bedifferent';
  
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // If passcode protection is disabled, always authorize
    if (!PASSCODE_ENABLED) {
      setIsAuthorized(true);
      setIsLoading(false);
      return;
    }

    // Check if user is already authorized (stored in localStorage)
    const authorized = localStorage.getItem('presspeels_authorized') === 'true';
    setIsAuthorized(authorized);
    setIsLoading(false);
  }, []);

  const handlePasscodeSubmit = (passcode) => {
    if (passcode === CORRECT_PASSCODE) {
      setIsAuthorized(true);
      localStorage.setItem('presspeels_authorized', 'true');
    } else {
      alert('Incorrect passcode. Please try again.');
    }
  };

  // Show loading state briefly
  if (isLoading) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>Loading...</div>;
  }

  // If not authorized, show coming soon page
  if (!isAuthorized) {
    return <ComingSoon onPasscodeSubmit={handlePasscodeSubmit} />;
  }

  // If authorized, show the actual app
  return children;
};

export default PasscodeGate; 